import React from 'react';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Moment from 'moment';
import validator from 'validator';
import PropTypes from 'prop-types';

import IndietroButton from '../../../components/IndietroButton';
import SpinnerComponent from '../../../components/SpinnerComponent';
import GiorniChiusuraEsercizio from './GiorniChiusuraEsercizio';
import FormPagamento from './FormPagamento';
import { getConsulenti } from '../../../utils/api/consulenti_api';
import { registerEsercizioWithResponsabile } from '../../../utils/api/esercizi_commerciali_api';
import { getGruppo } from '../../../utils/api/gruppi_api';
import FormDettagliNuovoEsercizio from './FormDettagliNuovoEsercizio';
import ConsulenteSelector from './ConsulenteSelector';
import ResponsabileSicurezzaForm from './ResponsabileSicurezzaForm';
import ControlloSemplificatoModal from './ControlloSemplificatoModal';
import { updateGestioneOperativaControlliSemplificati } from '../../../utils/api/aggiornamentoGestioneOperativaApi';
import { AUTH_TYPES } from '../../../auth/auth.options';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    paddingTop: '10px',
  },
});

class NuovoEsercizioConsulente extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      record: {
        esercizio: {
          id: null,
          nome: '',
          ragioneSociale: '',
          partitaIva: null,
          codiceAteco: null,
          telefono: null,
          nomeGestore: null,
          cognomeGestore: null,
          emailGestore: null,
          telefonoGestore: null,
          indirizzoSede: null,
          numeroSede: null,
          cittaSede: null,
          provinciaSede: null,
          consulenteId: null,
          codiceSdi: null,
          pec: null,
          terminiUsoAccettati: false,
          privacyPolicyAccettata: false,
          gruppoId: null,
          responsabileSicurezza: {
            email: '',
            password: '',
            confirmPassword: '',
            nome: '',
            cognome: '',
            telefono: '',
            terminiUsoAccettati: false,
            privacyPolicyAccettata: false,
            gruppoId: null,
            passwordEnabled: true,
            oauthEnabled: false,
          },
        },
        storicoPricing: {
          moltiplicatore: 1,
          anniValidita: 1,
          valoreIva: '',
          imponibile: '',
          totaleLordo: '',
          modalita: 'BONIFICO',
          consulenteId: this.props.consulenteId,
          esercizioCommercialeId: '',
          dataAggiornamento: '',
        },
        giorniChiusura: [],
      },
      validationErrors: {
        nome: '',
        ragioneSociale: '',
        email: '',
        password: '',
        confirmPassword: '',
        privacyPolicyAccettata: '',
        emailGestore: '',
      },
      costoUnitario: '',
      tipologiaPagamento: '',
      consulenti: [],
      showPassword1: false,
      disabledButtons: false,
      showPassword2: false,
      loading: true,
      saveButtonEnabled: false,
      saveMessageVisible: false,
      isControlloSemplificatoModalVisible: false,
    };
  }

  componentDidMount() {
    let record = this.state.record;
    record.esercizio.consulenteId = this.props.consulenteId;
    record.esercizio.gruppoId = this.props.gruppoId;
    record.esercizio.responsabileSicurezza.gruppoId = this.props.gruppoId;
    if (this.props.superconsulente) {
      this.setState({
        record,
      });
      this.fetchConsulenti(this.props.gruppoId);
    } else {
      this.setState({
        record,
        loading: false,
      });
    }
    this.fetchGruppo();
  }

  fetchGruppo = () => {
    getGruppo(this.props.gruppoId)
      .then((response) => {
        this.setState({
          costoUnitario: response.costoUnitario,
          tipologiaPagamento: response.tipologiaPagamento,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  fetchConsulenti = (gruppoId) => {
    getConsulenti(null, gruppoId, 0, 1000, 'id')
      .then((result) => {
        this.setState({
          loading: false,
          consulenti: result,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  updateParentState = (data) => {
    let record = this.state.record;
    record.giorniChiusura = data;
    this.setState({
      record: record,
      saveButtonEnabled: true,
    });
  };

  validateForm = () => {
    let data = this.state.record.esercizio;
    Object.keys(data).forEach((key) => {
      this.validateField(key, data[key]);
    });
    let responsabile = this.state.record.esercizio.responsabileSicurezza;
    Object.keys(responsabile).forEach((key) => {
      if (
        responsabile.passwordEnabled === false &&
        (key === 'password' || key === 'confirmPassword')
      ) {
        return;
      }
      this.validateFieldResponsabileSicurezza(key, responsabile[key]);
    });
    //Return false if there are validation errors:
    let valid = true;
    let validationErrors = this.state.validationErrors;
    Object.values(validationErrors).forEach((val) => {
      val.length > 0 && (valid = false);
    });
    return valid;
  };

  handleChangeAbbonamento = (value, fielName) => {
    if (!this.state.saveButtonEnabled) {
      this.setState({
        saveButtonEnabled: true,
      });
    }
    let data = this.state.record;
    data.storicoPricing[fielName] = value;
    this.setState({
      record: data,
    });
  };

  validateField = (key, value) => {
    let validationErrors = this.state.validationErrors;
    switch (key) {
      case 'nome':
        if (value === null || value.length === 0) {
          validationErrors.nome = 'Inserire nome';
        } else {
          validationErrors.nome = '';
        }
        break;
      case 'ragioneSociale':
        if (value === null || value.length === 0) {
          validationErrors.ragioneSociale = 'Inserire ragione sociale';
        } else {
          validationErrors.ragioneSociale = '';
        }
        break;
      case 'emailGestore':
        if (value === null || value.length === 0) {
          validationErrors.emailGestore =
            'Inserire indirizzo email del titolare';
        } else {
          if (validator.isEmail(value)) {
            validationErrors.emailGestore = '';
          } else {
            validationErrors.emailGestore =
              "L'indirizzo email inserito non è valido";
          }
        }
        break;
      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  validateFieldResponsabileSicurezza = (key, value) => {
    const rs = this.state.record.esercizio.responsabileSicurezza;

    if (
      !rs.passwordEnabled &&
      (key === 'password' || key === 'confirmPassword')
    ) {
      const validationErrors = this.state.validationErrors;
      validationErrors.password = '';
      validationErrors.confirmPassword = '';
      this.setState({ validationErrors });
      return;
    }

    let insertedPsw =
      this.state.record.esercizio.responsabileSicurezza.password;
    let validationErrors = this.state.validationErrors;

    switch (key) {
      case 'email':
        if (value.length === 0) {
          validationErrors.email = "Inserire l'indirizzo email";
        } else {
          if (validator.isEmail(value)) {
            validationErrors.email = '';
          } else {
            validationErrors.email = "L'indirizzo email inserito non è valido";
          }
        }
        break;
      case 'password':
        if (value.length >= 8) {
          validationErrors.password = '';
        } else {
          validationErrors.password =
            'Inserire una password di almeno 8 caratteri';
        }
        break;
      case 'confirmPassword':
        if (value.length === 0) {
          validationErrors.confirmPassword = 'Ripetere la password';
        } else {
          if (value === insertedPsw) {
            validationErrors.confirmPassword = '';
          } else {
            validationErrors.confirmPassword =
              'Le due password non corrispondono';
          }
        }
        break;

      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  onItemSelected = (value) => {
    if (!this.state.saveButtonEnabled) {
      this.setState({
        saveButtonEnabled: true,
      });
    }
    const consulenti = this.state.consulenti;
    let selectedConsulente = null;
    for (let i = 0; i < consulenti.length; i++) {
      if (consulenti[i].id === value) {
        selectedConsulente = consulenti[i];
        break;
      }
    }
    if (selectedConsulente !== null) {
      let record = this.state.record;
      record.esercizio.consulenteId = selectedConsulente.id;
      this.setState({
        record,
      });
    }
  };

  handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    this.setState((prevState) => {
      const record = { ...prevState.record };
      record.esercizio = { ...record.esercizio, [name]: fieldValue };

      const validationErrors = { ...prevState.validationErrors };
      if (
        name === 'nome' ||
        name === 'ragioneSociale' ||
        name === 'emailGestore'
      ) {
        validationErrors[name] = '';
      }

      return { record, validationErrors, saveButtonEnabled: true };
    });
  };

  handleChangeResponsabileSicurezza = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => {
      const record = { ...prevState.record };
      const rs = { ...record.esercizio.responsabileSicurezza };

      rs[name] = value;
      record.esercizio = { ...record.esercizio, responsabileSicurezza: rs };

      const validationErrors = { ...prevState.validationErrors };
      if (
        name === 'email' ||
        name === 'password' ||
        name === 'confirmPassword'
      ) {
        validationErrors[name] = '';
      }

      return { record, validationErrors, saveButtonEnabled: true };
    });
  };

  handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;

    this.setState((prevState) => {
      const record = { ...prevState.record };
      const rs = { ...record.esercizio.responsabileSicurezza };

      rs.passwordEnabled = isLocal;
      rs.oauthEnabled = !isLocal;

      if (!isLocal) {
        rs.password = '';
        rs.confirmPassword = '';
      }

      record.esercizio = { ...record.esercizio, responsabileSicurezza: rs };

      return {
        record,
        validationErrors: {
          ...prevState.validationErrors,
          password: '',
          confirmPassword: '',
        },
      };
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.validateForm()) return;

    const data = {
      ...this.state.record,
      storicoPricing:
        this.state.tipologiaPagamento === 'BIORSAF'
          ? {
              ...this.state.record.storicoPricing,
              dataAggiornamento: null,
            }
          : null,
    };
    this.setState({
      loading: true,
    });

    registerEsercizioWithResponsabile(data)
      .then((response) => {
        this.setState((prevState) => ({
          saveButtonEnabled: false,
          disabledButtons: true,
          saveMessageVisible: true,
          record: {
            ...prevState.record,
            aggiornamentoGestioneOperativaDTO:
              response.aggiornamentoGestioneOperativaDTO,
          },

          isControlloSemplificatoModalVisible:
            response.esercizio.gestioneOperativaSeparata &&
            !!response.aggiornamentoGestioneOperativaDTO,
        }));
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleClickShowPassword = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  onCloseControlloSemplificatoModal = () => {
    this.setState({
      isControlloSemplificatoModalVisible: false,
    });
  };

  onUpdateModalitaGestioneControlli = (isSemplificata) => {
    const { aggiornamentoGestioneOperativaDTO } = this.state.record;

    if (aggiornamentoGestioneOperativaDTO?.id == null) {
      return;
    }

    const id = aggiornamentoGestioneOperativaDTO.id;

    updateGestioneOperativaControlliSemplificati(id, isSemplificata)
      .then(() => {
        this.setState({
          isControlloSemplificatoModalVisible: false,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  render() {
    const { classes } = this.props;
    Moment.locale('it-IT');
    const disabledSubmitbutton =
      this.state.loading ||
      !this.state.saveButtonEnabled ||
      this.state.saveMessageVisible;
    let textFieldsDisabled = this.state.saveMessageVisible;

    return (
      <div className={classes.mainContainer}>
        <Typography variant="h4">Nuovo esercizio commerciale</Typography>
        <Grid
          container
          justify="center"
          style={{ marginTop: '26px', marginBottom: '26px' }}
        >
          <div style={{ minHeight: '500px' }}>
            {this.state.loading ? (
              <SpinnerComponent size={24} />
            ) : (
              <form autoComplete="off" onSubmit={this.handleSubmit}>
                <Container
                  style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}
                >
                  <Grid container justify="center" alignItems="center">
                    <FormDettagliNuovoEsercizio
                      handleChange={this.handleChange}
                      record={this.state.record}
                      textFieldsDisabled={textFieldsDisabled}
                      validationErrors={this.state.validationErrors}
                    />
                    {this.props.superconsulente && (
                      <ConsulenteSelector
                        consulenti={this.state.consulenti}
                        onItemSelected={this.onItemSelected}
                        record={this.state.record}
                        textFieldsDisabled={textFieldsDisabled}
                      />
                    )}
                    <ResponsabileSicurezzaForm
                      record={this.state.record}
                      handleAuthTypeChange={this.handleAuthTypeChange}
                      handleChangeResponsabileSicurezza={
                        this.handleChangeResponsabileSicurezza
                      }
                      handleClickShowPassword={this.handleClickShowPassword}
                      showPassword1={this.state.showPassword1}
                      showPassword2={this.state.showPassword2}
                      textFieldsDisabled={textFieldsDisabled}
                      validationErrors={this.state.validationErrors}
                    />
                  </Grid>
                </Container>
                {this.state.tipologiaPagamento === 'BIORSAF' && (
                  <FormPagamento
                    abbonamentoData={this.state.record.storicoPricing}
                    handleChangeAbbonamento={this.handleChangeAbbonamento}
                    costoUnitario={this.state.costoUnitario}
                    textFieldsDisabled={textFieldsDisabled}
                  />
                )}
                <GiorniChiusuraEsercizio
                  esercizioId={this.state.record.esercizio.id}
                  giorniChiusura={this.state.record.giorniChiusura}
                  updateParentState={this.updateParentState}
                  disabledButtons={this.state.disabledButtons}
                  updateGiorniChiusura={this.updateParentState}
                  theme={this.props.theme}
                />
                <Grid container justify="center" style={{ paddingTop: '10px' }}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ textAlign: 'center' }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: this.state.saveMessageVisible ? 'green' : 'red',
                        visibility:
                          this.state.saveMessageVisible ||
                          Object.values(this.state.validationErrors).some(
                            (err) => err.length > 0,
                          )
                            ? 'inherit'
                            : 'hidden',
                      }}
                    >
                      {this.state.saveMessageVisible
                        ? 'Nuovo esercizio commerciale registrato con successo'
                        : 'Compilare tutti i campi obbligatori evidenziati'}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ textAlign: 'right' }}
                  >
                    <IndietroButton isDisabled={this.state.loading} />
                    <Button
                      type="submit"
                      onClick={this.handleSubmit}
                      variant="contained"
                      size="medium"
                      disabled={disabledSubmitbutton}
                      style={{
                        color: disabledSubmitbutton
                          ? this.props.theme.palette.text.disabled
                          : this.props.theme.palette.text.main,
                        margin: '10px',
                        backgroundColor: disabledSubmitbutton
                          ? this.props.theme.palette.disabled.main
                          : this.props.theme.palette.primary.main,
                      }}
                    >
                      Salva
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </div>
        </Grid>
        {this.state.isControlloSemplificatoModalVisible && (
          <ControlloSemplificatoModal
            open={this.state.isControlloSemplificatoModalVisible}
            onClose={this.onCloseControlloSemplificatoModal}
            updateModalita={this.onUpdateModalitaGestioneControlli}
          />
        )}
      </div>
    );
  }
}

NuovoEsercizioConsulente.propTypes = {
  consulenteId: PropTypes.number.isRequired,
  gruppoId: PropTypes.number.isRequired,
  superconsulente: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(NuovoEsercizioConsulente);
